import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import translate from "@insite/client-framework/Translate";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { LinkPresentationProps } from "@insite/mobius/Link";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState, useEffect } from "react";
import { css } from "styled-components";

interface OwnProps {
    cart: Cart;
    /**
     * If true, the notes will display in a text field for editing.
     * If false, the notes will display as read-only text.
     * Default value: false
     */
    editable?: boolean;
    onNotesChange?: (updatedNotes: string) => void;
    label?: string;
    extendedStyles?: CartLineNotesStyles;
}

type Props = OwnProps & HasCartLineContext;

export interface CartLineNotesStyles {
    wrapper?: InjectableCss;
    /** @deprecated */
    toggleLink?: LinkPresentationProps;
    label?: TypographyPresentationProps;
    editableNotesTextArea?: TextFieldProps;
    readOnlyNotesText?: SmallHeadingAndTextStyles;
}

export const cartLineNotesStyles: CartLineNotesStyles = {
    wrapper: {
        css: css`
            width: 100%;
            /* padding-left: 26px; */
        `,
    },
    editableNotesTextArea: {
        css: css`
            min-width: 80%;
            max-width: 80%;
            min-height: 40px;
        `,
    },
    label: {
        css: css`
            button {
                /* border-bottom: 1px solid ${getColor("common.border")}; */
                color: #2e64b0;
                color: ${getColor("text.link")};
                background: none;
                border: none;
                padding: 0;
                font-size: 15px;
                cursor: pointer;
                padding-left: 16px;
                margin-top: 24px;
                margin-bottom: 26px;
            }
        `,
    },
};

const CartLineNotes: FC<Props> = ({
    cart,
    cartLine,
    editable = false,
    onNotesChange = () => {},
    label,
    extendedStyles,
}) => {

    const [notes, setNotes] = useState(cartLine.notes);

    const changeHandler = (event: any) => {
        setNotes(event.currentTarget.value);
    };

    const blurHandler = () => {
        onNotesChange(notes);
    };

    const [styles] = React.useState(() => mergeToNew(cartLineNotesStyles, extendedStyles));

    if (editable) {
        return (
            <StyledWrapper {...styles.wrapper}>
                    <TextField
                        {...styles.editableNotesTextArea}
                        value={notes}
                        id={`notes-${cartLine.id}`}
                        placeholder="Side Marks"
                        disabled={!cart.canModifyOrder}
                        onChange={e=>changeHandler(e)}
                        onBlur={blurHandler}
                        data-test-selector="cartline_notes"
                        maxLength={25}
                    />
            </StyledWrapper>
        );
    }

    if (!cartLine.notes) {
        return null;
    }

    return (
        <SmallHeadingAndText
            {...styles.readOnlyNotesText}
            heading={label || translate("Item Notes")}
            text={cartLine.notes}
        />
    );
};

export default withCartLine(CartLineNotes);
